import React from "react";
import { showMessage } from "react-native-flash-message";
import {
  Typography,
  OldButton as Button,
  Stack,
  Box,
  Divider,
  Spacer,
} from "digiwash-components";

import Icon from "../Icon";  
import useDeleteAddress from "../../hooks/useDeleteAddress";
import { Alert, Platform } from "react-native";

interface PropTypes {
  data: any;
}

function RowAddress(props: PropTypes) {
  let { deleteAddress, loading: isDeleting } = useDeleteAddress();
  const confirmationAlert = () => {
    if (Platform.OS === "web") {
      let confirmed = confirm(
        "توجه داشته باشید با حذف آدرس سفارش شما لغو نخواهد شد ، از حذف آدرس اطمینان دارید؟"
      );
      if (confirmed) {
        deleteAddress({ address_id: props.data.id });
      }
    }
    Alert.alert(
      "حذف آدرس",
      "توجه داشته باشید با حذف آدرس سفارش شما لغو نخواهد شد ، از حذف آدرس اطمینان دارید؟",
      [
        {
          text: "لغو",
          style: "cancel",
        },
        {
          text: "حذف",
          onPress: () => {
            deleteAddress({ address_id: props.data.id });
          },
        },
      ],
      { cancelable: false }
    );
  };
  return (
    <Box bg="primary.light940" distribution="space-between" p="m" br="l">
      <Stack distribution="space-between" px="xm" py="l">
        <Stack>
          <Icon name="map-pin" color="primary.main" size={16} />
          <Spacer size="xm" />
          {props.data.title && (
            <Typography fs="m" ff="mainBold" color="common.black">
              {props.data.title}
            </Typography>
          )}
        </Stack>
        <Stack>
          {/* <Button size="s" disabled={isDeleting}>
            <Icon name="edit-2" color="neutrals.800" size={18} />
          </Button>
          <Spacer size="s" /> */}
          <Button size="s" disabled={isDeleting} onPress={confirmationAlert}>
            <Icon name="trash-2" color="neutrals.800" size={18} />
          </Button>
        </Stack>
      </Stack>
      <Divider line="primary.light950" />
      <Box px="xm" py="l">
        <Typography fs="xm" color="neutrals.800">
          {props.data.address}
        </Typography>
      </Box>
    </Box>
  );
}

export default RowAddress;
